import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { LANGUAGES, useLanguage } from "../i18n/LanguageContext";
import "../styles/Navbar.css";

function Navbar() {
  const { lang, setLang, t } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="brand" onClick={closeMenu}>
          <img src="/images/logo/icone.png" alt="" />
          <span>Frost Wyrm Studios</span>
        </Link>

        <button
          className="menu-toggle"
          aria-expanded={menuOpen}
          aria-controls="nav-menu"
          aria-label={menuOpen ? t.nav.closeMenu : t.nav.openMenu}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? "✕" : "☰"}
        </button>

        <div id="nav-menu" className={`nav-menu ${menuOpen ? "open" : ""}`}>
          <ul className="nav-links">
            <li><NavLink to="/about" onClick={closeMenu}>{t.nav.about}</NavLink></li>
            <li><NavLink to="/contact" onClick={closeMenu}>{t.nav.contact}</NavLink></li>
          </ul>

          <div className="lang-switch" role="group" aria-label={t.nav.language}>
            {LANGUAGES.map((language) => (
              <button
                key={language.code}
                className={`lang-button ${lang === language.code ? "active" : ""}`}
                aria-pressed={lang === language.code}
                aria-label={language.label}
                title={language.label}
                lang={language.htmlLang}
                onClick={() => {
                  setLang(language.code);
                  closeMenu();
                }}
              >
                <img src={language.flag} alt="" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
